import filter from 'lodash/filter';
import head from 'lodash/head';

export class VolunteerProgramsMapService {
	constructor($resource, ApiService) {
		'ngInject';

		this.$resource = $resource;
        this.apiService = ApiService;

		this.volunteerProgramsMapResourceUrl = this.apiService.getResourceUrl('menus/VolunteerTransportationPrograms');
		this.volunteerProgramsDetailByIdResourceUrl = this.apiService.getResourceUrl('transportation-providers/:content_id');
		this.getAreaLatLngResourceUrl = this.apiService.getResourceUrl('service-area-latlng/:content_id');

		this.volunteerProgramsMapResource = this.$resource(this.volunteerProgramsMapResourceUrl);
		this.volunteerProgramsDetailByIdResource = this.$resource(this.volunteerProgramsDetailByIdResourceUrl);
		this.getAreaLatLngResource = this.$resource(this.getAreaLatLngResourceUrl);
    }

    _getOverviewDetailsObject(details) {
		return {
			contentId: details.content_id,
			menuId: details.menu_id,
			displayName: details.display_name,
			name: details.name,
			title: details.title,
			description: details.description
		}
    }

    _getHoursOfOperationDetails(value) {
		return {
			startTime: value.start_time,
			endTime: value.end_time,
			isAllDay: value.is_all_day,
			byAppointment: value.by_appoinment	
		}
	}

	_getCountyObject(values) {
		return values.map(value => ({
			id: value.county_id,
			name: value.county_name
		}));
	}

	_getServiceNameObject(values) {
		return values.map(value => ({
			id: value.service_area_id,
			name: value.service_name
		}));
	}

	_getServicetypeObject(values) {
		return values.map(value => ({
			id: value.service_type_id,
			name: value.service_type
		}));
	}

	_getPaymentMethodObject(values) {
		return values.map(value => ({
			id: value.payment_method_id,
			name: value.payment_method
		}));
	}

	_getPhoneDetailsObject(values) {
		return values.map(({extn = '', number = '', name = ''}) => ({extn, number, name}));
	}

	_getContentData(data) {
		return data.map(value => ({
			id: value.content_id,
			countyName: this._getCountyObject(value.county),
			daysOfOperation: value.days_of_operation,
			email: value.email,
			hoursOfOperation: this._getHoursOfOperationDetails(value.hours_of_operation),
			image: value.image,
			name: value.name,
			fees: value.fees,
			notes: value.notes,
			methodOfPayment: this._getPaymentMethodObject(value.payment_methods),
			phone: this._getPhoneDetailsObject(value.phone_number),
			// serviceName: this._getServiceNameObject(value.service_area),
			serviceType: this._getServicetypeObject(value.service_type),
			url: value.url,
			isSelected: false
		}));
	}

    _getVolunteerProgramsObject(values) {
        let details = filter(values, ['name', 'VolunteerProviders']);
        return this._getContentData(head(details).values);
	}
	
	_getVolunteerProgramsByIdObject(values) {
		let details = filter(values, ['name', 'TransportationProviders']);
        return this._getContentData(values.values);
	}
	
	_getLatLngObject(values) {
		return values.map(value => ({
			lat: parseFloat(value.lat),
			lng: parseFloat(value.lng)
		}));
	}

	_getPrivateProvidersData(values) {
		return values.map(value => {
			if(value) {
				return {
					name: value.name,
					type: value.type,
					latlng: this._getLatLngObject(value.latlng)
				}
			}
		});
	}

	_getAreaLatLngObject(data) {
		if(data.type === "area") {
			return {
				type: data.type,
				values: this._getPrivateProvidersData(data.values)
			};
		}
	}

	_getReferenceMapsObject(values) {
		let details = filter(values, ['name', 'referenceMap']);
		return _getMapsData(head(details).values);

		function _getMapsData(data) {
			return data.map(value => ({
				name: value.name,
				displayName: value.display_name
			}));
		}
	}

    getVolunteerProgramsData() {
		const promise = this.volunteerProgramsMapResource.get().$promise;

		return promise.then(details => ({
            menuOverviewDetails: this._getOverviewDetailsObject(details.data.menuOverviewDetails),
            volunteerPrograms: this._getVolunteerProgramsObject(details.data.content),
            referenceMaps: this._getReferenceMapsObject(details.data.content)
		})).catch((error) => {
			throw this.apiService.getErrorMessage(error);
		});
	}

	getVolunteerProgramsdetailById(id) {
		const promise = this.volunteerProgramsDetailByIdResource.get({
			content_id: id
		}).$promise;
		
		return promise.then(details => ({
			volunteerPrograms: this._getVolunteerProgramsByIdObject(details.data)
		}))
		.catch((error) => {
			throw this.apiService.getErrorMessage(error);
		});
	}

	getAreaLatLngData(id) {
		const promise = this.getAreaLatLngResource.get({
			content_id: id
		}).$promise;

		return promise.then(details => this._getAreaLatLngObject(details.data));
	}
}


// WEBPACK FOOTER //
// ./src/app/components/planning-resources-volunteer-programs/planning-resources-volunteer-programs.service.js